import { render, staticRenderFns } from "./settingWoocommerce.vue?vue&type=template&id=10f2ec01&scoped=true&"
import script from "./settingWoocommerce.vue?vue&type=script&lang=js&"
export * from "./settingWoocommerce.vue?vue&type=script&lang=js&"
import style0 from "./settingWoocommerce.vue?vue&type=style&index=0&id=10f2ec01&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f2ec01",
  null
  
)

export default component.exports